// Paleta Azul Corporativo del reporte de Gasto Fijo.
export const paletaVars = () => ({
  "--gf-title": "#0F2A4A", "--gf-head": "#1E4E79", "--gf-total": "#E8EEF5", "--gf-info": "#EEF4FB",
  "--gf-info-text": "#0F2A4A", "--gf-comp": "#D6E4F0", "--gf-comp-soft": "#EEF4FB",
});
